import { z } from 'zod';

export const ProviderTypeSchema = z.enum(['gitlab', 'github', 'bitbucket', 'gitea', 'generic']);

export const GitAuthMethodSchema = z.enum(['pat', 'oauth', 'none']);

export const GitServerSchema = z.object({
  id: z.string(),
  display_name: z.string(),
  provider_type: ProviderTypeSchema,
  base_url: z.string(),
  is_active: z.boolean(),
  has_service_account_token: z.boolean(),
  login_provider_id: z.string().nullable().optional(),
  login_provider_name: z.string().nullable().optional(),
});

export const GitCredentialSchema = z.object({
  server_id: z.string(),
  server_display_name: z.string(),
  server_provider_type: ProviderTypeSchema,
  has_token: z.boolean(),
  git_user_name: z.string().nullable(),
  git_user_email: z.string().nullable(),
  auth_method: GitAuthMethodSchema,
  login_provider_name: z.string().nullable(),
  login_connected: z.boolean(),
});

export const GitProjectSchema = z.object({
  id: z.string(),
  server_id: z.string(),
  external_ref: z.string(),
  name: z.string(),
  path: z.string(),
  default_branch: z.string().nullable(),
  clone_url: z.string().nullable(),
});

export const GitBranchSchema = z.object({
  name: z.string(),
  commit_sha: z.string(),
  protected: z.boolean(),
});

export const GitServersResponseSchema = z.object({ servers: z.array(GitServerSchema) });
export const GitCredentialResponseSchema = GitCredentialSchema;
export const GitCredentialsListSchema = z.object({ credentials: z.array(GitCredentialSchema) });
export const GitProjectsListSchema = z.object({
  projects: z.array(GitProjectSchema),
  page: z.number(),
  per_page: z.number(),
  total: z.number().nullable(),
});
export const GitBranchesResponseSchema = z.object({
  branches: z.array(GitBranchSchema),
  default_branch: z.string().nullable(),
});

// Inferred types from schemas
export type ProviderType = z.infer<typeof ProviderTypeSchema>;
export type GitAuthMethod = z.infer<typeof GitAuthMethodSchema>;
export type GitServer = z.infer<typeof GitServerSchema>;
export type GitCredential = z.infer<typeof GitCredentialSchema>;
export type GitProject = z.infer<typeof GitProjectSchema>;
export type GitBranch = z.infer<typeof GitBranchSchema>;
export type GitServersResponse = z.infer<typeof GitServersResponseSchema>;
export type GitCredentialsList = z.infer<typeof GitCredentialsListSchema>;
export type GitProjectsList = z.infer<typeof GitProjectsListSchema>;
export type GitBranchesResponse = z.infer<typeof GitBranchesResponseSchema>;
